import styled from 'styled-components';

const ErrorMessage = styled.div`
	color: red;
	margin: 0.25rem 0 1.5rem;
	width: 100%;
`;

export default ErrorMessage;
